import { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import CloseIcon from '@/assets/common/close.svg?react';
import styles from './AddHeadingModal.module.scss';

interface AddHeadingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (title: string) => void;
  isSubmitting?: boolean;
}

export function AddHeadingModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting = false,
}: AddHeadingModalProps) {
  const [title, setTitle] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!title.trim()) {
      setError('Heading title is required');
      return;
    }

    onSubmit(title.trim());
    setTitle('');
  };

  const handleClose = () => {
    setTitle('');
    setError(null);
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.addHeadingModal__overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClose}
        >
          <motion.div
            className={styles.addHeadingModal__content}
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.addHeadingModal__header}>
              <h2 className={styles.addHeadingModal__title}>Add Heading</h2>
              <button
                className={styles.addHeadingModal__closeButton}
                onClick={handleClose}
              >
                <CloseIcon />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className={styles.addHeadingModal__body}>
                <div className={styles.addHeadingModal__field}>
                  <label className={styles.addHeadingModal__label}>
                    Heading Title
                  </label>
                  <input
                    type="text"
                    className={styles.addHeadingModal__input}
                    placeholder="Enter heading title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    autoFocus
                  />
                </div>

                {error && (
                  <div className={styles.addHeadingModal__error}>{error}</div>
                )}
              </div>

              <div className={styles.addHeadingModal__footer}>
                <button
                  type="button"
                  className={`${styles.addHeadingModal__button} ${styles['addHeadingModal__button--secondary']}`}
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`${styles.addHeadingModal__button} ${styles['addHeadingModal__button--primary']}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Adding...' : 'Add Heading'}
                </button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
